export default "__VITE_ASSET__D2WN0VAK__"